/** @format */

import style from "./index.module.scss";
import { useState, useEffect } from "react";
import btn_backfrom from "../../assets/images/btn_back.png";
import MochiImage_modal from "../common/modal/MochiImage_modal";

import ButtonCircle from "../common/button/ButtonCircle";
import AccountOperations from "../services/AccountOperations";
import { createCookieThatLastsForADay } from "../../untils/helpers";

import ModalInput from "../common/modal/ModalInput";

const Signup = ({ setPageLoginSignup, setIsLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [userName, setUserName] = useState("");
    const [erroUserName, setErroUserName] = useState("");

    const [erroEmail, setErroEmail] = useState("");
    const [erroPassword, setErroPassword] = useState("");

    const [showPassword, setShowPassword] = useState(false);
    const [activeButton, setActiveButton] = useState(false);

    const middlewareEmail = (value) => {
        const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (value.length === 0) {
            setErroEmail("* Email không được bỏ trống");
        } else if (value.match(regex)) {
            setErroEmail("");
        } else {
            setErroEmail("* Email sai định dạng, bạn kiểm tra lại nhé");
        }
    };
    useEffect(() => {
        if (
            email.length &&
            password.length &&
            userName.length &&
            !erroUserName.length &&
            !erroEmail.length &&
            !erroPassword.length
        ) {
            setActiveButton(true);
        } else {
            setActiveButton(false);
        }
    }, [email, password, userName, erroEmail, erroPassword, erroUserName]);

    const middlewarePassword = (value) => {
        if (value.length === 0) {
            setErroPassword("* Mật khẩu không được bỏ trống");
        } else if (value.length < 6) {
            setErroPassword("* Mật khẩu cần có ít nhất 06 ký tự");
        } else {
            setErroPassword("");
        }
    };
    const middlewareUserName = (value) => {
        if (value.length === 0) {
            setErroUserName("* Tên hiển thị không được bỏ trống");
        } else if (value.length < 3 || value.length >= 15) {
            setErroUserName("* Tên hiển thị cần có từ 3-15 ký tự");
        } else {
            setErroUserName("");
        }
    };

    const handleSubmitSignup = async () => {
        if (!activeButton) return;

        try {
            let result = await AccountOperations.handleSignupEmail({
                email: email,
                display_name: userName,
                password: password,
                // lang: null
                // trial_course: 1
            });
            if (result.code === 1) {
                createCookieThatLastsForADay("email", result.user?.email);
                createCookieThatLastsForADay(
                    "user_token",
                    result.user?.user_token
                );
                // setIsOpenPopupLoginSignup({ type: null, isOpen: false });
                setPageLoginSignup([]);
                setIsLogin(true);
            } else if (result.code === 0) {
                setErroEmail(result.errors?.email[0]);
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <>
            <div className={style.loginScreen}>
                <div
                    className={style.loginScreen_title}
                    style={{ marginBottom: "5%" }}>
                    <h1 style={{ margin: "0 -13px" }}>
                        Cùng tạo 1 tài khoản Mochi nào
                    </h1>
                </div>
                <div className={style.firstScreen_img}>
                    <MochiImage_modal />
                </div>
                <div className={style.loginScreen_options}>
                    <div className={style.formInput}>
                        <div
                            className={
                                style.formInput_container +
                                " " +
                                (erroUserName.length !== 0
                                    ? style.formInput_container_erro
                                    : "")
                            }>
                            <ModalInput
                                controller={[userName, setUserName]}
                                placeholder={"Tên của bạn"}
                                middleware={middlewareUserName}
                            />
                        </div>
                        <p className={style.erroMessage}>
                            {erroUserName || ""}
                        </p>

                        <div
                            className={
                                style.formInput_container +
                                " " +
                                (erroEmail.length !== 0
                                    ? style.formInput_container_erro
                                    : "")
                            }>
                            <ModalInput
                                controller={[email, setEmail]}
                                placeholder={"Nhập email tài khoản học"}
                                middleware={middlewareEmail}
                            />
                        </div>
                        <p className={style.erroMessage}>{erroEmail || ""}</p>

                        <div
                            className={
                                style.formInput_container +
                                " " +
                                (erroPassword.length !== 0
                                    ? style.formInput_container_erro
                                    : "")
                            }>
                            <ModalInput
                                controller={[password, setPassword]}
                                placeholder={"Nhập mật khẩu tài khoản học"}
                                middleware={middlewarePassword}
                                type={showPassword ? "text" : "password"}
                            />
                            <p
                                onClick={() => setShowPassword((prev) => !prev)}
                                className={
                                    style.formInput_container_controllPassType
                                }>
                                {password.length !== 0 &&
                                    (showPassword ? "Ẩn" : "Hiển thị")}
                            </p>
                        </div>
                        <p className={style.erroMessage}>
                            {erroPassword || ""}
                        </p>

                        <div className={style.formInput_submitLine}>
                            <ButtonCircle
                                onClick={handleSubmitSignup}
                                fontSize="20px"
                                buttonText="Tạo tài khoản"
                                disable={!activeButton}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Signup;
